__turbopack_context__.v({
  "airlineIcon": "QC-9ZG_airlineIcon",
  "lg": "QC-9ZG_lg",
  "md": "QC-9ZG_md",
  "size2xl": "QC-9ZG_size2xl",
  "sm": "QC-9ZG_sm",
  "xl": "QC-9ZG_xl",
  "xs": "QC-9ZG_xs",
});
